import debounce from "lodash/debounce";

const MOBILE_BREAKPOINT = 768;
const LAYOUT_RESIZE_DEBOUNCE_MS = 150;

const isChrome =
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.location.href.indexOf("sarv") > -1;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isIphone = /(iPhone|iPad)/i.test(navigator.userAgent) || window.location.href.indexOf("sarv") > -1;;

const isAndroidDesktopMode = () => {
  const ua = navigator.userAgent;
  const isAndroid = /Android/i.test(ua);
  const isLinux = /Linux/i.test(navigator.platform);
  const hasTouch = navigator.maxTouchPoints > 0;

  // Linux + Touch + No "Android" in UA usually means Android Desktop Mode
  return !isAndroid && isLinux && hasTouch;
};

const getIsMobileLayout = () =>
  isMobileDevice || window.innerWidth < MOBILE_BREAKPOINT;

// isMobile drives the layout and follows the window width, so it is exported as
// a live binding. Use isMobileDevice for anything sent to the API or for logic
// that must not change when a desktop window is resized.
let isMobile = getIsMobileLayout();

const layoutChangeListeners = new Set();

const subscribeToLayoutChange = (listener) => {
  layoutChangeListeners.add(listener);
  return () => layoutChangeListeners.delete(listener);
};

window.addEventListener(
  "resize",
  debounce(() => {
    const nextIsMobile = getIsMobileLayout();
    if (nextIsMobile === isMobile) {
      return;
    }
    isMobile = nextIsMobile;
    layoutChangeListeners.forEach((listener) => listener());
  }, LAYOUT_RESIZE_DEBOUNCE_MS)
);

export {
  MOBILE_BREAKPOINT,
  isChrome,
  isMobile,
  isMobileDevice,
  isSafari,
  isIphone,
  isAndroidDesktopMode,
  subscribeToLayoutChange,
};
